import { render } from "./pictureDesktop.vue?vue&type=template&id=46203ecd&scoped=true"
import script from "./pictureDesktop.vue?vue&type=script&lang=js"
export * from "./pictureDesktop.vue?vue&type=script&lang=js"

import "./pictureDesktop.vue?vue&type=style&index=0&id=46203ecd&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46203ecd"]])

export default __exports__